import React, { useState } from "react";

function App() {
  // State to track the active navigation item
  const [activeItem, setActiveItem] = useState("项目");

  const navItems = [
    "项目",
    "详情",
    "活动",
    "周围分析",
    "CI / CD",
    "运维",
    "设置",
  ];

  return (
    <div className="flex h-screen bg-gray-100">
      {/* 左侧导航栏 */}
      <aside className="w-64 bg-gray-800 text-white">
        <div className="px-4 py-6">
          <h2 className="text-xl font-semibold">GitLab</h2>
        </div>
        <nav className="mt-6">
          <ul>
            {navItems.map((item) => (
              <li
                key={item}
                className={`px-4 py-2 cursor-pointer ${
                  activeItem === item
                    ? "bg-gray-700 font-bold"
                    : "hover:bg-gray-700"
                }`}
                onClick={() => setActiveItem(item)}
              >
                {item}
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {/* 主内容区域 */}
      <main className="flex-1 overflow-auto">
        {/* 标题栏 */}
        <header className="bg-white shadow-sm">
          <div className="container mx-auto px-6 py-4">
            <h1 className="text-2xl font-bold text-gray-800">rust-red-web</h1>
            <p className="text-gray-600">react前端</p>
          </div>
        </header>

        {/* 项目信息 */}
        <div className="container mx-auto px-6 py-4">
          {/* 顶部操作栏 */}
          <div className="flex items-center justify-between">
            <div>
              <button className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700">
                添加更新日志
              </button>
              <button className="ml-2 px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700">
                添加贡献者
              </button>
            </div>
            <div>
              <button className="px-4 py-2 text-white bg-orange-600 rounded hover:bg-orange-700">
                启用 Auto DevOps
              </button>
            </div>
          </div>

          {/* 文件列表 */}
          <div className="mt-6 bg-white shadow rounded">
            <table className="min-w-full table-auto">
              <thead>
                <tr className="bg-gray-200 text-gray-600 uppercase text-sm">
                  <th className="px-6 py-3 text-left">名称</th>
                  <th className="px-6 py-3 text-left">最后提交</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="px-6 py-3">
                    <span className="text-blue-600 hover:underline cursor-pointer">
                      public
                    </span>
                  </td>
                  <td className="px-6 py-3 text-gray-600">节点显示</td>
                </tr>
                <tr className="border-b">
                  <td className="px-6 py-3">
                    <span className="text-blue-600 hover:underline cursor-pointer">
                      src
                    </span>
                  </td>
                  <td className="px-6 py-3 text-gray-600">界面调整</td>
                </tr>
                <tr className="border-b">
                  <td className="px-6 py-3">
                    <span className="text-blue-600 hover:underline cursor-pointer">
                      .gitignore
                    </span>
                  </td>
                  <td className="px-6 py-3 text-gray-600">Initial commit</td>
                </tr>
                <tr>
                  <td className="px-6 py-3">
                    <span className="text-blue-600 hover:underline cursor-pointer">
                      package.json
                    </span>
                  </td>
                  <td className="px-6 py-3 text-gray-600">
                    添加节点连接划线
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
